var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBothsideViewBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 64,
    viewBox: "0 0 84 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 4H44L44 60H76C80.4183 60 84 56.866 84 53V11C84 7.13401 80.4183 4 76 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H40L40 60H8C3.58172 60 0 56.866 0 53V11C0 7.13401 3.58172 4 8 4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 32C28 31.4477 27.5523 31 27 31H15.83L20.71 26.12C21.1017 25.7283 21.1006 25.0928 20.7075 24.7025C20.3164 24.3141 19.6848 24.3152 19.295 24.705L13.4142 30.5858C12.6332 31.3668 12.6332 32.6332 13.4142 33.4142L19.2947 39.2947C19.6842 39.6842 20.3158 39.6842 20.7053 39.2947C21.0946 38.9054 21.0949 38.2743 20.7059 37.8847L15.83 33H27C27.5523 33 28 32.5523 28 32Z",
    fill: "#212529",
    stroke: "#212529"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 32C56 31.4477 56.4477 31 57 31H68.17L63.29 26.12C62.8983 25.7283 62.8994 25.0928 63.2925 24.7025C63.6836 24.3141 64.3152 24.3152 64.705 24.705L70.5858 30.5858C71.3668 31.3668 71.3668 32.6332 70.5858 33.4142L64.7053 39.2947C64.3158 39.6842 63.6842 39.6842 63.2947 39.2947C62.9054 38.9054 62.9051 38.2743 63.2941 37.8847L68.17 33H57C56.4477 33 56 32.5523 56 32Z",
    fill: "#212529",
    stroke: "#212529"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBothsideViewBig);
export default __webpack_public_path__ + "static/media/bothside-view-big.669f96b8.svg";
export { ForwardRef as ReactComponent };